import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';

const AccountsTextPopup = ({ popupRef = null, ...props }) => {
    const gotIt = props.gotIt || props.bankAccountCheckPopupGotIt;
    const text = props.info || props.openedAllAccountsTitle;

    const getText = (text) => {
        return <DangerouslyHtml dangerouslyHtml={text} />;
    };

    return (
        <SimplePopup text={getText(text)} popupRef={popupRef}>
            <PopupButton
                title="Got it"
                iconName="check"
                text={gotIt}
                onClick={(e) => {
                    e.preventDefault();
                    if (props.closeHandler) {
                        props.closeHandler();
                    } else {
                        popupRef.current?.close();
                    }
                }}
            />
        </SimplePopup>
    );
};

AccountsTextPopup.propTypes = {
    popupRef: PropTypes.shape({ current: PropTypes.object }),
};

const mapStateToProps = (state) => {
    return {
        openedAllAccountsTitle: state.messages.pageMessages.openedAllAccountsTitle,
        gotIt: state.messages.pageMessages.gotIt,
        bankAccountCheckPopupGotIt: state.messages.pageMessages.bankAccountCheckPopupGotIt,
    };
};

export default connect(mapStateToProps)(AccountsTextPopup);
